<div mat-dialog-header>
    <h1 mat-dialog-title fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <mat-icon *ngIf="ShowIcon" [style.color]="IconColor">{{IconName}}</mat-icon>
        <span>{{TitleText}}</span>
    </h1>
</div>
<div mat-dialog-content>
    <div [innerHTML]="MessageText | safeHTML"></div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="OKHandler()">{{OKText}}</button>
</div>